var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrev(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 15,
    fill: "#FFF",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.67 7.5l5.803-5.803a.924.924 0 00.286-.7.994.994 0 00-.305-.701A.958.958 0 007.753 0a.958.958 0 00-.7.296L.992 6.375a1.577 1.577 0 00-.355.533A1.584 1.584 0 00.52 7.5c0 .197.039.394.118.592.079.197.197.375.355.533l6.079 6.079a.912.912 0 00.69.286.984.984 0 00.692-.306.958.958 0 00.296-.7.958.958 0 00-.296-.701L2.67 7.5z"
  })));
}
export default SvgPrev;